export enum TicketTypeEnum {
  GREEN = 'green-key',
  BLUE = 'blue-key',
  ORANGE = 'orange-key',
}
